import React, { FC } from 'react'
import styled from 'styled-components'
import Img from '../assets/img__offer-messages.png'
import { ETypeRequest, IIndexEgePageProps } from '../types'
import ImgBg from '../assets/img__offer-1_desktop.png'
import { EApplicationFormProductTypes } from '../../../../../components/AppliactionForm/types'
import ImgBottomLeft from '../assets/img__form1_left_bottom_desktop.png.png'
import ImgBottomRight from '../assets/img__form1_right_bottom_desktop.png'
import SchoolForm from '../../../../../components/Blocks/SchoolForm/desktop'

const BottomLeft = styled.img`
  position: absolute;
  bottom: -120px;
  width: 120px;
  left: 0;
  z-index: 1;
`

const BottomRight = styled.img`
  position: absolute;
  bottom: -120px;
  width: 120px;
  right: 0;
  z-index: 1;
`

const IndexEgePageForm1: FC<
  IIndexEgePageProps['content']['offer'] & {
    totalDiscount: number
  }
> = (props) => {
  const { title, totalDiscount } = props

  return (
    <SchoolForm
      title={title.desktop}
      img={Img}
      bgImg={ImgBg}
      productType={EApplicationFormProductTypes.ege}
      requestTarget={ETypeRequest.ege_lead_request}
      totalDiscount={totalDiscount}
    >
      <BottomLeft src={ImgBottomLeft} />
      <BottomRight src={ImgBottomRight} />
    </SchoolForm>
  )
}

export default IndexEgePageForm1
